import React from 'react';
import styles from './Footer.module.css';

const Footer: React.FC = () => (
  <div className={styles.footbar}>
    <span>© MMXXVI Oak Cliff Tech</span>
    <span className={styles.glyphs}>▦ ◆ ▸ ✦</span>
    <a
      className={styles.madeIn}
      href="https://hollowdepth.com"
      target="_blank"
      rel="noopener noreferrer"
    >
      Made w/ <span className={styles.heart}>♥</span> in Oak Cliff
    </a>
  </div>
);

export default Footer;
